import { render, staticRenderFns } from "./TDSModal.vue?vue&type=template&id=a81e735e&scoped=true"
import script from "./TDSModal.ts?vue&type=script&lang=ts&external"
export * from "./TDSModal.ts?vue&type=script&lang=ts&external"
import style0 from "./TDSModal.scss?vue&type=style&index=0&id=a81e735e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81e735e",
  null
  
)

export default component.exports